import React from 'react';
import DateRangePicker from '../../../element/daterangepicker';
import Title from '../../../element/title';
import url from '../../../urlhandler/urlHandlerActions';
import clone from 'clone';

class DateRangePickerDropDownPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'values': 'Demo Input',
      'options': [],
      'toogle': false,
    };
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.changeToogle = this.changeToogle.bind(this);
    this.handleDateRange = this.handleDateRange.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.block = nextprops.block;
    const datepickertype = nextprops.block.hasOwnProperty('selectedCalenderViewType') ? nextprops.block.selectedCalenderViewType : 'single';
    this.setState({ datepickertype, toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  handleDateRange(values) {
    if (this.block !== undefined) {
      if (this.block.selectedMetakey) {
        url.push({
          'searchItem': this.block.selectedMetakey,
          'searchType': 'metakeys',
          'searchField': 'daterange',
          values,
        });
      }
    }
    // this.setState({ values });
  }
  render() {
    const allUrlData = window.searchArray;
    const defaultValue = {};
    allUrlData.map((item) => {
      const isDateRangeStart = item.key.indexOf('[start]');
      if (isDateRangeStart !== -1) {
        defaultValue.start = item.value;
      }
      const isDateRangeEnd = item.key.indexOf('[end]');
      if (isDateRangeEnd !== -1) {
        defaultValue.end = item.value;
      }
    });
    const textBoxClassName = this.props.block.dynamicNameClassCheckBox;
    const HelperClass = this.state.toogle ? 'single-component' : '';
    return (<div className={textBoxClassName}>
      <Title
        title={this.props.block.title}
        subtitle={this.props.block.subtitle}
        toogle= {this.state.toogle}
        onToogle = {this.changeToogle}
        selectedToogleViewType = {'true'}
        dropdown = {true}
        field={this.props.block.uid}
      />
      { this.state.toogle ? <div className= {HelperClass + ' ' + 'dropdown-template'}><DateRangePicker {...this.props} dateFormat={this.block.dateFormat !== undefined ? this.block.dateFormat : 'MM-DD-YYYY' } default={defaultValue} datepickertype={this.state.datepickertype} grabDateRangeValue={this.handleDateRange} /></div> : null }
    </div>);
  }
}

DateRangePickerDropDownPreview.propTypes = {
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default DateRangePickerDropDownPreview;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/dropdown/daterangepickerdropdownpreview.js
 **/